// --> React
import React from 'react';

import './estimateForm.module.scss';

export default function EstimateForm() {
	return (
		<iframe
			src='https://docs.google.com/forms/d/e/1FAIpQLSddWUrHPtY70j-hRJ-naCrCZLCyHBIWHTRDx2zDk5g5MwTIVA/viewform?embedded=true'
			width='100%'
			height='100%'
			title='request-estimate'
			frameBorder='0'
			marginHeight='0'
			marginWidth='0'>
			Loading…
		</iframe>
	);
}
